import { createAsyncThunk } from '@reduxjs/toolkit';

import type { GroupCreateRequest, GroupDto } from '../../api/types';
import { entitiesActions } from '../slices/entitiesSlice';
import { uiActions } from '../slices/uiSlice';
import type { RootState } from '../store';

import { groupsService } from './_deps';

export const createGroup = createAsyncThunk<GroupDto, GroupCreateRequest, { state: RootState }>(
  'groups/create',
  async (payload, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    try {
      const group = await groupsService.createGroup({ payload });
      dispatch(entitiesActions.upsertGroups([group]));
      return group;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Не удалось создать группу';
      throw error;
    }
  },
);
